import React, { Component } from 'react';
import Heading from '../components/Heading';
import TeamsList from '../components/Teams/TeamsList';

export default class Teams extends Component {
  render() {
    return (
      <div className="teams">
        <Heading text="Teams" />
        <TeamsList type="view" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Teams.jsx